<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>


        <v-dialog v-model="dialog.delete"
          @keydown.esc="dialog.delete = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              Hapus Data

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-4">
              Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">Fasilitas</b> yang Anda pilih?
            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="deletes()"
                :loading="process.delete"
                :disabled="process.delete"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Ya, Hapus
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                :disabled="process.delete"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.form"
          @keydown.esc="dialog.form = false"
          :fullscreen="dialog.fullscreen"
          v-if="dialog.form"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                {{ form.id === '' ? 'Tambah' : 'Ubah' }} Fasilitas 
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.form = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <ValidationProvider 
                    name="Nama Fasilitas" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>

                      Nama Fasilitas
                    </div>

                    <v-text-field
                      v-on:keyup.enter="save()"
                      
                      outlined
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Contoh. Fasilitas Umum"

                      hide-details

                      v-model="form.name"
                      :error-messages="errors"
                      required
                      style="border-radius: 10px;"
                      class="mb-4">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>
                        
                        <div v-if="form.name !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>


                  <ValidationProvider 
                    name="Qty Fasilitas" 
                    rules="required|min_value:1" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>

                      Qty Fasilitas
                    </div>

                    <v-currency-field
                      v-on:keyup.enter="save()"
                      
                      outlined
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Contoh. Fasilitas Umum"

                      hide-details

                      v-model="form.qty"
                      :error-messages="errors"
                      required
                      style="border-radius: 10px;"
                      class="mb-4">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>
                        
                        <div v-if="form.qty !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-currency-field>
                  </ValidationProvider>

                  <ValidationProvider 
                    name="Harga" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>

                      Harga
                    </div>

                    <v-currency-field
                      v-on:keyup.enter="save()"
                      
                      outlined
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Contoh. 100000"

                      hide-details

                      v-model="form.price"
                      :error-messages="errors"
                      required
                      style="border-radius: 10px;"
                      class="mb-4">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>
                        
                        <div v-if="form.price !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-currency-field>
                  </ValidationProvider>

                  <ValidationProvider 
                    name="Dapat Disewakan" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>

                      Dapat Disewakan
                    </div>

                    <v-select
                      v-on:keyup.enter="save()"
                      
                      outlined
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Pilih Opsi"

                      hide-details

                      v-model="form.is_sell"
                      :items="[
                        { text: 'Ya', value: '1' },
                        { text: 'Tidak', value: '0' }
                      ]"
                      :error-messages="errors"
                      required
                      style="border-radius: 10px;"
                      class="mb-4">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>
                        
                        <div v-if="form.is_sell !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-select>
                  </ValidationProvider>
                </v-form>
              </ValidationObserver>

            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>
              
            <v-card-actions
              class="pa-4">
              <div v-if="message.error.length > 0"
                class="text-center">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
              <v-spacer/>

              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn
                @click="dialog.form = false; reset();"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <section>

          <v-row
            class="pa-0">
            <v-col 
              cols="12"
              class="py-0">
              <div>
                <div class="font_weight_600 fs-14 black--text">
                  <div class="mb-2">
                    Fasilitas yang dapat disewa
                  </div>
                  <v-btn
                    color="#4B4B4B"
                    elevation="0"
                    x-small
                    @click="reset(); dialog.form = true"
                    min-height="25"
                    class="fs-12 white--text text-capitalize d-flex align-center"
                    style="border-radius: 6px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1)); margin-bottom: 3px;;">
                    <v-icon size="13">mdi-plus-circle-multiple</v-icon>
                    
                    <span
                      class="ml-2">
                      Tambah
                    </span>
                  </v-btn>
                </div>
                <div>
                  <div>
                    <v-row>
                      <v-col cols="12" md="12" class="pt-0">
                        <table style="border: 1px solid #ededed; width: 100%; border-collapse: collapse;">
                          <tr>
                            <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center;" class="black--text">
                              Aksi
                            </th>
                            <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left;" class="black--text">
                              Nama
                            </th>
                            <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left;" class="black--text">
                              Jumlah
                            </th>
                            <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left;" class="black--text">
                              Harga
                            </th>
                            <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left;" class="black--text">
                              Dapat Disewakan
                            </th>
                          </tr>
                          <tr v-for="(item, i) in fasilitas" :key="i">
                            <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 120px; min-width: 120px; max-width: 120px;" class="black--text">
                              <v-tooltip 
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="reset(i); dialog.form = true"

                                    min-width="25"
                                    height="25"
                                    x-small
                                    rounded
                                    color="blue"
                                    elevation="0"
                                    class="white--text text-capitalize mx-1 px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon size="14">mdi-square-edit-outline</v-icon>
                                  </v-btn>
                                </template>

                                <span>Ubah</span>
                              </v-tooltip>
                              <v-tooltip 
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    @click="toDelete(item.id)"
                                    
                                    v-bind="attrs"
                                    v-on="on"
                                    
                                    min-width="24" min-height="24"
                                    x-small
                                    rounded
                                    color="red"
                                    elevation="0"
                                    class="white--text text-capitalize mx-1 px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon size="15">mdi-trash-can-outline</v-icon>
                                  </v-btn>
                                </template>

                                <span>Hapus</span>
                              </v-tooltip>
                            </td>
                            <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; min-width: 300px;" class="black--text">
                              {{ item.name }}
                            </td>
                            <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left;" class="black--text">
                              {{ item.qty }}
                            </td>
                            <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left;" class="black--text">
                              {{ item.price ? new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR' }).format(item.price) : '-' }}
                            </td>
                            <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left;" class="black--text">
                              {{ item.is_sell === '1' || item.is_sell === 1 ? 'Ya' : (item.is_sell === '0' || item.is_sell === 0 ? 'Tidak' : '-') }}
                            </td>
                          </tr>
                        </table>
                      </v-col>
                    </v-row>
                  </div>
                  <div v-if="fasilitas.length == 0" class="text-center py-5">
                    <!-- <v-icon size="100" color="grey lighten-1">mdi-emoticon-sad-outline</v-icon> -->
                    <v-img 
                      class="mx-auto"
                      contain
                      alt="vuetify"
                      :width="40"
                      :height="40"
                      :src="require('@/assets/image/empty.png')">
                    </v-img>
                    <div class="fs-12 black--text">
                      Fasilitas belum tersedia
                    </div>
                  </div>
                  <!-- <div class="d-flex align-center mt-0 mb-1">
                    <div>
                      <v-icon
                        color="#AD1457"
                        size="16"
                      >mdi-face-woman-shimmer</v-icon>
                    </div>
                    <div class="black--text text-lighten-1 fs-13 pt-1 ml-3">
                      Tempat Rias
                    </div>
                  </div>
                  <div class="d-flex align-center mt-0 mb-1">
                    <div>
                      <v-icon
                        color="#1B5E20"
                        size="16"
                      >mdi-forest</v-icon>
                    </div>
                    <div class="black--text text-lighten-1 fs-13 pt-1 ml-3">
                      Halaman Depan
                    </div>
                  </div> -->
                </div>
              </div>
            </v-col>
          </v-row>

        </section>
      </v-flex>
    </v-layout>
  </div>
</template>
  
<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  
  export default {
    data: () => ({
      dialog: {
        form: false,
        fullscreen: false,
        delete: false,
        snackbar: false
      },
      fasilitas: [],
      form: {
        id: '',
        name: '',
        qty: '',
        price: '',
        is_sell: ''
      },
      selected: {
        row: [],
        delete: []
      },
      message: {
        success: '',
        error: ''
      },
      process: {
        form: false,
        submit: false,
        delete: false,
        load: false
      },
    }),
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      user () {
        return this.$store.state.user
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      // this.$refs.calendar.checkChange()
      this.fetch()
    },
    methods: {

      async fetch () {
        let params = {
          product_id: this.$route.params.id
        }
        await get(`admin/product_facility/data`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.status === 200) {
            this.fasilitas = res.results.data
          }
        })
      },
      reset (index) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.form = {
          id: index !== undefined ? this.fasilitas[index].id : '',
          name: index !== undefined ? this.fasilitas[index].name : '',
          qty: index !== undefined ? this.fasilitas[index].qty : '',
          price: index !== undefined ? this.fasilitas[index].price : '',
          is_sell: index !== undefined ? this.fasilitas[index].is_sell : ''
        }

        this.process.form = false

        this.message.error = ''
      },
      viewDay ({ date }) {
        this.focus = date
        this.type = 'day'
      },
      getEventColor (event) {
        return event.color
      },
      setToday () {
        this.focus = ''
      },
      prev () {
        this.$refs.calendar.prev()
      },
      next () {
        this.$refs.calendar.next()
      },
      showEvent ({ nativeEvent, event }) {
        const open = () => {
          this.selectedEvent = event
          this.selectedElement = nativeEvent.target
          requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
        }

        if (this.selectedOpen) {
          this.selectedOpen = false
          requestAnimationFrame(() => requestAnimationFrame(() => open()))
        } else {
          open()
        }

        nativeEvent.stopPropagation()
      },
      updateRange ({ start, end }) {
        const events = []

        const min = new Date(`${start.date}T00:00:00`)
        const max = new Date(`${end.date}T23:59:59`)
        const days = (max.getTime() - min.getTime()) / 86400000
        const eventCount = this.rnd(days, days + 20)

        for (let i = 0; i < eventCount; i++) {
          const allDay = this.rnd(0, 3) === 0
          const firstTimestamp = this.rnd(min.getTime(), max.getTime())
          const first = new Date(firstTimestamp - (firstTimestamp % 900000))
          const secondTimestamp = this.rnd(2, allDay ? 288 : 8) * 900000
          const second = new Date(first.getTime() + secondTimestamp)

          events.push({
            name: this.names[this.rnd(0, this.names.length - 1)],
            start: first,
            end: second,
            color: this.colors[this.rnd(0, this.colors.length - 1)],
            timed: !allDay,
          })
        }

        this.events = events
      },
      rnd (a, b) {
        return Math.floor((b - a + 1) * Math.random()) + a
      },

      // POST FASILITAS

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          let url = this.form.id === '' ? 'admin/product_facility/add' : 'admin/product_facility/update'

          // SAVE TO REST API
          await post(url, {
            data: {
              id: this.form.id,
              name: this.form.name,
              qty: this.form.qty,
              price: this.form.price,
              is_sell: this.form.is_sell,
              product_id: this.$route.params.id
            }
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              this.fetch()
              this.reset()

            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },


      // DELETE FASILITAS

      toDelete (id) {
        this.selected.delete = [id]

        this.dialog.delete = true
      },
      async deletes () {
        this.message.error = ''

        this.process.delete = true

        await post(`admin/product_facility/delete`, {
          data: {
            id: this.selected.delete[0]
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {

            this.dialog.delete = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch()
          } else {
            this.message.error = res.message
          }
        })
      },
    },
  }
</script>